import { useEffect, useRef, useState } from 'react'

export const defaultFloatOptions = {
  openDelay: 100,
  closeDelay: 100,
}

export interface UseFloatHoverOptions {
  openDelay?: number
  closeDelay?: number
}

interface UseFloatHoverResult {
  show: boolean
  open: () => void
  close: () => void
  delayOpen: () => void
  delayClose: () => void
}

export const useFloatHover = (
  options: UseFloatHoverOptions = defaultFloatOptions,
): UseFloatHoverResult => {
  const [show, setShow] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearTimer = (): void => {
    if (timer.current !== null) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }

  const open = (): void => {
    clearTimer()
    setShow(true)
  }

  useEffect(
    () => () => {
      if (timer.current !== null) {
        clearTimeout(timer.current)
        timer.current = null
      }
    },
    [],
  )

  const delayOpen = (): void => {
    clearTimer()
    timer.current = setTimeout(() => {
      timer.current = null
      setShow(true)
    }, options.openDelay ?? defaultFloatOptions.openDelay)
  }

  const close = (): void => {
    clearTimer()
    setShow(false)
  }

  const delayClose = (): void => {
    clearTimer()
    timer.current = setTimeout(() => {
      timer.current = null
      setShow(false)
    }, options.closeDelay ?? defaultFloatOptions.closeDelay)
  }
  return { show, open, close, delayClose, delayOpen }
}
